import styles from "./RereservationIncentiveBanner.module.scss"

import ticketIcon from "@/public/images/incentive_icons/ticket.svg"
import { toStringWithCommas } from "@/utils/strings/number"

type Props = {
	price: number
	cancelId: string
	customerName: string
	originPrice: number
}

// DISCOUNT (500円OFF) バナー
// design 参照: frontend/design/public/rereservation.pen Frame 2ddNw 内 "Gift Campaign Section" (id: HgFb9)
const DiscountBanner = ({
	price,
	cancelId,
	customerName,
	originPrice,
}: Props) => {
	const priceText = toStringWithCommas(price)
	const originPriceText = "¥" + toStringWithCommas(originPrice)
	const discountedPrice = Math.max(0, originPrice - price)
	const discountedPriceText = "¥" + toStringWithCommas(discountedPrice)

	return (
		<div className={styles.container}>
			<div className={`${styles.header} ${styles.headerDiscount}`}>
				<div className={`${styles.headerTitle} ${styles.headerTitleDiscount}`}>
					<img
						src={ticketIcon}
						alt=""
						className={styles.headerIcon}
						aria-hidden="true"
					/>
					<span>
						{customerName}様 期間限定 ¥{priceText} OFF
					</span>
				</div>
				<span className={styles.headerBadge}>適用中</span>
			</div>

			<div className={styles.mainCard}>
				<div className={styles.mainSubtitle}>{customerName}様 期間限定</div>
				<div className={styles.mainAmountRow}>
					<div className={styles.mainAmount}>¥{priceText}</div>
					<div className={styles.mainAmountUnit}>OFF</div>
				</div>
				<div className={styles.mainNote}>再予約金額から自動で割引適用</div>
			</div>

			<div className={styles.priceRow}>
				<div className={`${styles.priceBox} ${styles.priceBoxNormal}`}>
					<div className={`${styles.priceLabel} ${styles.priceLabelNormal}`}>
						通常メニュー
					</div>
					<div className={`${styles.priceValue} ${styles.priceValueNormal}`}>
						{originPriceText}
					</div>
				</div>
				<span className={styles.priceArrow} aria-hidden="true">
					▶
				</span>
				<div
					className={`${styles.priceBox} ${styles.priceBoxApplied} ${styles.priceBoxAppliedDiscount}`}
				>
					<div className={`${styles.priceLabel} ${styles.priceLabelApplied}`}>
						適用後
					</div>
					<div className={`${styles.priceValue} ${styles.priceValueApplied}`}>
						{discountedPriceText}
					</div>
				</div>
			</div>

			<div className={styles.cancelIdText}>クーポン番号: {cancelId}</div>

			<div className={styles.notesBox}>
				<div className={styles.notesLine}>
					・本画面から予約のみ対象となります
				</div>
				<div className={styles.notesLine}>・期間超過後の再発行はできません</div>
			</div>
		</div>
	)
}

export default DiscountBanner
